import React from "react";
import "./Loader.css";
import logo from "../assets/logos/2-Photoroom.png";

function Loader() {
  return (
    <div className="loader">

      <div className="loader-glow"></div>

      <div className="loader-content">

        <img
          src={logo}
          alt="Creative Studio"
          className="loader-logo"
        />

        <div className="loader-line">
          <span></span>
        </div>

        <p className="loader-text">
          CREATIVE STUDIO
        </p>

      </div>

    </div>
  );
}

export default Loader;